import React from 'react';
import { NavLink } from 'react-router-dom';

const navStyle = isActive => ({
  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px',
  padding: '8px 12px', color: isActive ? '#f59e0b' : '#64748b',
  fontWeight: isActive ? '700' : '400', fontSize: '10px', textDecoration: 'none',
  borderTop: isActive ? '2px solid #f59e0b' : '2px solid transparent',
  background: 'none', border: 'none', cursor: 'pointer', flex: 1
});

export default function Layout({ children, onLogout }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', paddingBottom: '70px' }}>
      <div style={{ background: 'linear-gradient(135deg,#1e293b,#334155)', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>📦 Lager Organizer</span>
        <button onClick={onLogout} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', padding: '6px 12px', borderRadius: '8px', cursor: 'pointer' }}>Abmelden</button>
      </div>
      <div style={{ maxWidth: '600px', margin: '0 auto', padding: '16px' }}>{children}</div>
      <nav aria-label="Hauptnavigation" style={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: 'white', borderTop: '1px solid #e2e8f0', display: 'flex', zIndex: 100 }}>
        <NavLink to="/" end style={({ isActive }) => navStyle(isActive)} aria-label="Startseite"><span style={{ fontSize: '20px' }}>🏠</span>Start</NavLink>
        <NavLink to="/behaelter" style={({ isActive }) => navStyle(isActive)} aria-label="Kisten verwalten"><span style={{ fontSize: '20px' }}>📦</span>Kisten</NavLink>
        <NavLink to="/suche" style={({ isActive }) => navStyle(isActive)} aria-label="Artikel suchen"><span style={{ fontSize: '20px' }}>🔍</span>Suche</NavLink>
        <NavLink to="/inventar" style={({ isActive }) => navStyle(isActive)} aria-label="Inventar ansehen"><span style={{ fontSize: '20px' }}>📋</span>Inventar</NavLink>
        <NavLink to="/einstellungen" style={({ isActive }) => navStyle(isActive)} aria-label="Standorte verwalten"><span style={{ fontSize: '20px' }}>📍</span>Standorte</NavLink>
      </nav>
    </div>
  );
}
